enum HotKeyEnum {
  SHIFT = "⇧",
  ALT = "⌥",
  COMMAND = "⌘",
  CTRL = "⌃",
  SPACE = "space"
}

export default HotKeyEnum;
